import styled from 'styled-components';
import { variables } from '../../../../styles/variables';
export const ArrayStringStyle = styled('ul')`
    list-style-type: none;
    padding-left: 0px;
    margin-bottom: 0;
`;

export const CollapseListStyle = styled('div')`
    .ant-collapse{
        background-color: unset;
        font-size: inherit;
        font-family: inherit;
    }
    .ant-collapse-borderless > .ant-collapse-item {
        border-bottom: none;
        li {
            color: ${variables.colorMainText};
        }
        & > .ant-collapse-header {
            padding: 0;
            padding-left: 25px;
        }
        .ant-collapse-arrow {
            left: 0;
        }
    }
    .ant-collapse-content-box {
        padding: 5px;
    }
`;